/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popUpgradestar.vue?vue&type=template&id=8d2ce928&scoped=true"
import script from "./popUpgradestar.vue?vue&type=script&lang=js"
export * from "./popUpgradestar.vue?vue&type=script&lang=js"
import style0 from "./popUpgradestar.vue?vue&type=style&index=0&id=8d2ce928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2ce928",
  null
  
)

export default component.exports